import { Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	selected: boolean;
	onClick: () => void;
	children: ReactNode;
};

export const InspirationChoiceTile: FC<Props> = ({
	selected,
	onClick,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack
			flex={1}
			alignItems="center"
			py={1.2}
			px={0.8}
			onClick={onClick}
			borderRadius={theme.radii.lg}
			bgcolor={selected ? theme.palette.blue[50] : theme.palette.surface.muted}
			sx={{ cursor: "pointer" }}
		>
			{children}
		</Stack>
	);
};
